import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "w-full flex flex-col gap-3"
};
const _hoisted_2 = {
  class: "w-full flex items-center justify-between gap-6"
};
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  class: "w-full flex items-center gap-4 mt-4"
};
const _hoisted_5 = {
  class: "ml-auto"
};
const _hoisted_6 = {
  class: "relative flex items-center justify-between gap-3"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "w-fit text-[11px] text-main-50 [tr:hover_&]:text-main-100 font-light transition-colors"
};
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center gap-3 text-xs"
};
const _hoisted_10 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_11 = {
  class: "text-2xs"
};
const _hoisted_12 = {
  class: "pointer-events-none exluded-tr"
};
const _hoisted_13 = {
  colspan: "100"
};
const _hoisted_14 = {
  class: "w-full flex flex-col items-start gap-3 text-xs pb-3 animate-fade"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                        
  const _component_Button = _resolveComponent("Button");
                                                      
                                                                    
                                                                    
                                                                                  
                                                                          
                                                                
                                                                    
  const _directive_ptooltip = _resolveDirective("ptooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("p", {
    class: "text-lg font-medium"
  }, "Historial de robots", -1)), _ctx.stats ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_chip, {
    color: "wg",
    "append-icon": "icon-flow",
    text: `Nuestros robots han trabajado ${_ctx.stats.totalLogs} veces para ti`,
    size: "small"
  }, null, 8, ["text"]), _createVNode(_component_v_chip, {
    color: "wg",
    "append-icon": "icon-diamond",
    text: _ctx.$st('payments.used-slans', {
      value: _ctx.stats.slans
    }),
    size: "small"
  }, null, 8, ["text"]), this.logs?.total ? (_openBlock(), _createBlock(_component_Button, {
    key: 0,
    variant: "outlined_light",
    size: "xs",
    text: "Generar reporte",
    icon: "icon-excel-icon",
    loading: this.loading.logReport,
    onClick: _cache[0] || (_cache[0] = $event => this.GetFlowLogsReport())
  }, null, 8, ["loading"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_v_btn_toggle, {
    modelValue: _ctx.query.isScheduled,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.query.isScheduled = $event),
    mandatory: "",
    class: "shrink-0",
    density: "compact",
    color: "second"
  }, {
    default: _withCtx(() => [_createVNode(_component_v_btn, {
      class: "text-xs normal-case tracking-normal"
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("Todos")])),
      _: 1
    }), _createVNode(_component_v_btn, {
      class: "text-xs normal-case tracking-normal"
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("Manuales")])),
      _: 1
    }), _createVNode(_component_v_btn, {
      class: "text-xs normal-case tracking-normal"
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Programados y remotos")])),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_Button, {
    variant: "outlined_light",
    icon: "icon-refresh",
    size: "sm",
    loading: _ctx.loading.flowLogs,
    onClick: $options.GetFlowHistory
  }, null, 8, ["loading", "onClick"]), _createElementVNode("div", _hoisted_5, [_ctx.logs?.total ? (_openBlock(), _createBlock(_component_v_pagination, {
    key: 0,
    modelValue: _ctx.query.page,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.query.page = $event),
    totalVisible: "4",
    length: Math.ceil(_ctx.logs.total / _ctx.query.limit),
    disabled: _ctx.loading.flowLogs,
    class: "w-full [&_span]:text-xs!",
    density: "comfortable"
  }, null, 8, ["modelValue", "length", "disabled"])) : _createCommentVNode("", true)])]), _createVNode(_component_v_data_table, {
    headers: _ctx.headers,
    items: _ctx.logs?.items,
    loading: _ctx.loading.flowLogs,
    hover: true,
    "items-per-page": _ctx.query.limit,
    "item-value": "_id",
    "hide-default-footer": "",
    expanded: _ctx.expanded,
    "onUpdate:expanded": _cache[3] || (_cache[3] = $event => _ctx.expanded = $event),
    "no-data-text": "No se han encontrado registros",
    "loading-text": "Cargando...",
    class: "overflow-hidden w-full rounded-lg text-xs [&_tbody_tr:nth-child(odd):not(.exluded-tr)]:bg-main-10 [&_tbody_tr:nth-child(even):not(.exluded-tr)]:bg-main-5 **:border-0!"
  }, {
    "item.robot": _withCtx(({
      item
    }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [item.browserFlow ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.browserFlow.name), 1)) : (_openBlock(), _createBlock(_component_v_chip, {
      key: 1,
      color: "main",
      text: "Este robot ya no forma parte de nuestra familia",
      size: "x-small"
    })), _createElementVNode("p", _hoisted_8, _toDisplayString(item.user), 1)]), _createVNode(_component_v_chip, {
      color: item.scheduled ? 'cta' : 'second',
      text: item.executionType,
      size: "x-small"
    }, null, 8, ["color", "text"])])]),
    "item.result": _withCtx(({
      item
    }) => [item.status === 200 || item.status === 500 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("p", null, "(" + _toDisplayString(item.successfulIterations) + "/" + _toDisplayString(item.totalIterations) + ")", 1), item.relation ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(!isNaN(item.relation) ? item.relation : 0) + "%", 1), _createVNode(_component_v_progress_circular, {
      "model-value": item.relation,
      size: 13,
      width: 2,
      color: item.relation < 75 ? 'cta2' : 'second'
    }, null, 8, ["model-value", "color"])])) : _createCommentVNode("", true)])) : item.status && item.status in _ctx.FlowDetailsController.infoByStatus ? _withDirectives((_openBlock(), _createBlock(_component_v_chip, _mergeProps({
      key: 1
    }, _ctx.FlowDetailsController.infoByStatus[item.status], {
      size: "x-small"
    }), null, 16)), [[_directive_ptooltip, _ctx.FlowDetailsController.infoByStatus[item.status].description]]) : isNaN(item.relation) ? (_openBlock(), _createBlock(_component_v_chip, {
      key: 2,
      color: "error",
      text: "Error inesperado",
      size: "x-small"
    })) : _createCommentVNode("", true)]),
    "item.button": _withCtx(({
      item
    }) => [item.normalizedUserLogStreams?.length ? (_openBlock(), _createBlock(_component_v_btn, {
      key: 0,
      variant: "tonal",
      color: "second",
      icon: _ctx.expanded[0] === item._id ? 'icon-chevron-up text-sm' : 'icon-chevron-down text-sm',
      density: "comfortable",
      size: "small",
      class: _normalizeClass(["opacity-0 [tr:hover_&]:opacity-100! transition-none", {
        'opacity-100!': _ctx.expanded[0] === item._id
      }]),
      onClick: $event => _ctx.expanded = _ctx.expanded[0] === item._id ? [] : [item._id]
    }, null, 8, ["icon", "class", "onClick"])) : _createCommentVNode("", true)]),
    "expanded-row": _withCtx(({
      item
    }) => [_createElementVNode("tr", _hoisted_12, [_createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_v_timeline, {
      side: "end",
      density: "comfortable",
      "truncate-line": "end"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.normalizedUserLogStreams, msg => {
        return _openBlock(), _createBlock(_component_v_timeline_item, {
          key: msg,
          "dot-color": msg.color,
          size: "x-small"
        }, {
          opposite: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$formatDate({
            date: msg.timestamp,
            format: 'hh:mm:ss'
          })), 1)]),
          default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(msg.text), 1)]),
          _: 2
        }, 1032, ["dot-color"]);
      }), 128))]),
      _: 2
    }, 1024)])])])]),
    _: 1
  }, 8, ["headers", "items", "loading", "items-per-page", "expanded"])]);
}

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"
import { VBtnToggle as _component_v_btn_toggle } from "vuetify/components/VBtnToggle"
import { VChip as _component_v_chip } from "vuetify/components/VChip"
import { VDataTable as _component_v_data_table } from "vuetify/components/VDataTable"
import { VPagination as _component_v_pagination } from "vuetify/components/VPagination"
import { VProgressCircular as _component_v_progress_circular } from "vuetify/components/VProgressCircular"
import { VTimelineItem as _component_v_timeline_item, VTimeline as _component_v_timeline } from "vuetify/components/VTimeline"

